import React, { useState } from 'react';
import { PiEye, PiEyeSlash } from 'react-icons/pi';
import { IInputProps } from 'types/components/inputs/input.interface';
import InputWrapper from '../wrapper/InputWrapper';
import './PasswordInput.scss';

const PasswordInput = (props: IInputProps) => {
  const [showPassword, setShowPassword] = useState(false);

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  return (
    <InputWrapper
      {...props}
      render={inputProps => (
        <div className="password-input-container">
          <input 
            {...inputProps} 
            type={showPassword ? 'text' : 'password'}
          />
          <button
            type="button"
            className="password-toggle-button"
            onClick={togglePasswordVisibility}
            tabIndex={-1}
          >
            {showPassword ? <PiEyeSlash /> : <PiEye />}
          </button>
        </div>
      )}
    />
  );
};

export default PasswordInput; 